import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import Loader from '../../components/Loader/Loader';
import Swal from 'sweetalert2';

const Notes = () => {
  const { id } = useParams();
  const [loader, setLoader] = useState(false);

  const [isSlipModalOpen, setIsSlipModalOpen] = useState(false);

  const [notes, setNotes] = useState([]);

  useEffect(() => {
    fetchNotesDetails(id);
  }, [id]);

  const fetchNotesDetails = (courseId) => {
    setLoader(true);
    const requestOptions = {
      method: 'GET',
      redirect: 'follow'
    };

    fetch(`https://quran-backend-theta.vercel.app/v1/admin/notes/${courseId}`, requestOptions)
      .then((response) => response.text())
      .then((result) => {
        let data = JSON.parse(result);
        console.log('DATA', data);
        setNotes(data?.notes);
        setLoader(false);
      })
      .catch((error) => console.error(error));
  };

  const handleDeleteClick = (note) => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this note!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.isConfirmed) {
        setLoader(true);

        const myHeaders = new Headers();
        myHeaders.append('Content-Type', 'application/json');
        myHeaders.append('Accept', 'application/json');
        myHeaders.append('Access-Control-Allow-Origin', '*');
        myHeaders.append('Authorization', `Bearer ${localStorage.getItem('token')}`);

        const requestOptions = {
          method: 'DELETE',
          headers: myHeaders,
          redirect: 'follow'
        };

        fetch(`https://quran-backend-theta.vercel.app/v1/admin/notes/${id}/${note}`, requestOptions)
          .then((response) => response.text())
          .then((result) => {
            let data = JSON.parse(result);

            if (data.success === true) {
              Swal.fire({
                title: 'Deleted!',
                text: 'Your note has been deleted.',
                icon: 'success',
                confirmButtonText: 'OK'
              }).then(() => {
                fetchNotesDetails(id);
              });
            }

            if (data?.success === false) {
              if (data?.message === 'Expired') {
                localStorage.clear();
                window.location.reload();
                setLoader(false);
              } else {
                setLoader(false);
                toast.error(data?.message);
              }
            }
          })
          .catch((error) => {
            console.error(error);
            Swal.fire({
              title: 'Error!',
              text: 'An error occurred while deleting the note.',
              icon: 'error',
              confirmButtonText: 'OK'
            });
            setLoader(false);
          });
      }
    });
  };

  return (
    <section className="mb-20 mt-7">
      {loader === true ? (
        'Loading...'
      ) : (
        <div className="rounded-lg overflow-x-auto">
          {notes && notes?.length > 0 ? (
            <div className="flex flex-col">
              <div className="sm:-mx-6 lg:-mx-8">
                <div className="inline-block min-w-full sm:px-6 lg:px-8">
                  <div className="overflow-hidden">
                    <table className="min-w-full mb-0">
                      <thead>
                        <tr className="rounded-lg whitespace-nowrap">
                          <th className="text-sm text-primary font-bold px-6 py-4">Sr#</th>
                          <th className="text-sm text-primary font-bold px-6 py-4">Title</th>
                          <th className="text-sm text-primary font-bold px-6 py-4">Attachment</th>
                          <th className="text-sm text-primary font-bold px-6 py-4">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {notes?.map((student, index) => (
                          <>
                            <tr
                              key={student?._id}
                              style={{
                                boxShadow: '0px 0px 63.44px 0px #00000012'
                              }}
                              className="bg-white border-b-8 border-white rounded-md"
                            >
                              <td className="align-middle bg-white text-sm font-normal px-6 py-3 whitespace-nowrap text-center">
                                <span className="bg-white text-base text-black py-1 px-2.5 leading-none text-center whitespace-nowrap align-baseline bg-green-200 rounded-full">
                                  {index + 1}
                                </span>
                              </td>

                              <td className="align-middle bg-white text-sm font-normal px-6 py-3 whitespace-nowrap text-center">
                                <span className="bg-white text-base text-black py-1 px-2.5 leading-none text-center whitespace-nowrap align-baseline bg-green-200 rounded-full">
                                  {student?.title}
                                </span>
                              </td>

                              <td className="align-middle bg-white text-center text-sm font-normal px-6 py-4 whitespace-nowrap">
                                <Link
                                  to={student?.content}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="text-secondary"
                                >
                                  {student?.content?.split('/').pop()}
                                </Link>
                              </td>
                              {isSlipModalOpen && (
                                <div
                                  className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
                                  // onClick={closeModal}
                                >
                                  <div
                                    className="bg-white p-6 rounded shadow-lg max-w-xl w-full relative"
                                    onClick={(e) => e.stopPropagation()} // Prevent closing modal when clicking inside
                                  >
                                    {/* X Icon for closing */}
                                    <button
                                      // onClick={closeModal}
                                      className="absolute top-2 right-2 text-gray-500 hover:text-red-500"
                                    >
                                      ✕
                                    </button>

                                    <h2 className="text-lg font-bold mb-4">Fee Slip</h2>

                                    <img
                                      src={student?.feeStatus?.slipUrl}
                                      alt="Fee Slip"
                                      className="w-full h-auto rounded mb-4"
                                    />

                                    <div className="flex justify-end gap-4">
                                      {/* Cancel Button */}
                                      <button
                                        // onClick={closeModal}
                                        className="px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
                                      >
                                        Cancel
                                      </button>

                                      {/* Approve Button */}
                                      <button
                                        onClick={() => ApproveFee(student)}
                                        className="px-4 py-2 bg-[#FF7E00] text-white rounded"
                                        disabled={isModelLoading} // Disable button during loading
                                      >
                                        {isModelLoading ? (
                                          <div className="spinner-border animate-spin w-5 h-5 border-t-2 border-white rounded-full" />
                                        ) : (
                                          'Approve'
                                        )}
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              )}

                              <td className="align-middle bg-white text-center text-sm font-normal px-6 py-4 whitespace-nowrap">
                                <div className=" flex justify-center items-center gap-3">
                                  {/* <img
                                        src={require('../../assets/image/edit.png')}
                                        onClick={() => {
                                          setUpdateCources(true);
                                          setSingle(courseDetails);
                                        }}
                                        alt="Delete"
                                        style={{ cursor: 'pointer' }}
                                      /> */}
                                  <img
                                    src={require('../../assets/image/del.png')}
                                    onClick={() => handleDeleteClick(student?._id)}
                                    alt="Delete"
                                    style={{ cursor: 'pointer' }}
                                  />
                                </div>
                              </td>
                            </tr>
                          </>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="text-center text-lg font-semibold text-gray-600 mt-10">
              No Data Available
            </div>
          )}
        </div>
      )}
    </section>
  );
};

export default Notes;
